
















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import parsePhoneNumber from 'libphonenumber-js';
import PhonePrefix from './PhonePrefix.vue';

@Component({
  components: {
    PhonePrefix,
  },
})
export default class PhoneInput extends Vue {
  @Prop() public phoneValue!: string;
  @Prop({ default: '+48' }) public codeValue!: string;

  public phone: string = '';

  public onPhoneValueChange(val: string) {
    this.$emit('change', {
      phone: val,
      code: this.codeValue,
    });
  }

  public onCodeValueChange(val: string) {
    this.$emit('change', {
      phone: this.phoneValue,
      code: val,
    });
  }

  public validate() {
    const phoneNumber = parsePhoneNumber(this.codeValue + this.phoneValue);
    if (phoneNumber) {
      return phoneNumber.isValid();
    } else {
      return false;
    }
  }
}
